import { Table } from "react-bootstrap";

function SentRefundRequest() {
  return (
    <section className="sectionPD">
      <div className="container">
        <div className="fisherman-content">
          <h3>Applied Refund Request</h3>
        </div>
        <div className="table-responsive">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Order Id</th>
                <th>Product</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Mark</td>
                <td>Otto</td>
                <td>@mdo</td>
                <td>@mdo</td>
                <td>@mdo</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </section>
  );
}
export default SentRefundRequest;
